import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import injectSheet from 'react-jss';

import { Button } from '~/eds/src/components/Button/Button';
import { IconButton } from '~/eds/src/components/IconButton/IconButton';
import { injectIntl } from 'react-intl';

import { black5, evisortBlue } from '../../../assets/shared-styles/general';
import { MODAL_SEARCH_WITHIN_PROVISION } from '../../../types/modal.types';
import EcModal from '../EcModal/EcModal';
import EcMultipleSelectValue from '../EcMultipleSelectValue/EcMultipleSelectValue';
import EcSelect from '../EcSelect/EcSelect';
import SearchIcon from '../Icons/SearchIcon';
import SubArrowIcon from '../Icons/SubArrowIcon';
import styles from './EcFilterProvision.styles';

class EcFilterProvision extends Component {
  constructor(props) {
    super(props);

    this.handleOnRelationChange = this.handleOnRelationChange.bind(this);
    this.handleOnSearchProvisionClick =
      this.handleOnSearchProvisionClick.bind(this);
    this.handleUpdateFilter = this.handleUpdateFilter.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);

    this.state = { modal: null };
  }

  handleOnRelationChange(contains) {
    this.props.onChange({ contains });
  }

  handleOnSearchProvisionClick() {
    this.setState({ modal: MODAL_SEARCH_WITHIN_PROVISION });
  }

  handleUpdateFilter(filterIndex, filter) {
    const text_search = filter.textSearch.map((searchFilter) => {
      return {
        contains: searchFilter.filterContains,
        scope: searchFilter.filterScope,
        text: searchFilter.filterPhrase,
      };
    });

    this.props.onChange({
      text_search: [...this.props.text_search, ...text_search],
    });
  }

  handleOnProvisionRemoveClick(textIndex) {
    const { text_search } = this.props;

    const newTextSearch = [...text_search];
    newTextSearch.splice(textIndex, 1);

    this.props.onChange({ text_search: newTextSearch });
  }

  handleHideModal() {
    this.setState({ modal: null });
  }

  renderSearchProvisionModal() {
    const { provision, contains: filterRelation, intl } = this.props;

    const filterValue = { label: provision, value: provision };
    const selectedFilter = { filterRelation, filterValue };

    return (
      <EcModal
        modalType={MODAL_SEARCH_WITHIN_PROVISION}
        width="790px"
        title={intl.formatMessage({
          id: 'EcFilterProvision.searchWithinClauseTitle',
          defaultMessage: 'Search Within Clause',
          description: 'Modal title for searching within clause',
        })}
        hideModal={this.handleHideModal}
        filter={selectedFilter}
        filterIndex={null}
        handleUpdateFilter={this.handleUpdateFilter}
      />
    );
  }

  renderProvisionTextValues() {
    const { classes, text_search, contains, intl } = this.props;

    if (contains.value === 'does_not_contain') return null;

    return (
      <div className={classes.provisionValuesContainer}>
        {text_search.map((provisionTextValue, index) => {
          const { contains, scope, text } = provisionTextValue;
          const provision = (
            <Fragment>
              {contains.label} {scope.label}
              &nbsp;
              <b>{text.split(' ').join(', ')}</b>
            </Fragment>
          );

          return (
            <div
              className={classes.provisionTextContainer}
              key={`provision-text-${index}`}
            >
              <SubArrowIcon color={black5} />
              <div className={classes.provisionText}>
                <EcMultipleSelectValue
                  label={provision}
                  key={index}
                  closeHandler={() => this.handleOnProvisionRemoveClick(index)}
                />
              </div>
            </div>
          );
        })}

        <div className={classes.searchProvisionWrapper}>
          <button
            className={classes.searchProvisionAction}
            onClick={this.handleOnSearchProvisionClick}
          >
            <SearchIcon size="20" opacity="1" color={evisortBlue} />
            {intl.formatMessage({
              id: 'EcFilterProvision.searchWithinClauseButton',
              defaultMessage: 'Search within clause',
              description: 'Button text for searching within clause',
            })}
          </button>
        </div>
      </div>
    );
  }

  render() {
    const {
      classes,
      provision,
      contains,
      onRemoveClick,
      onFilterNameClick,
      intl,
    } = this.props;
    const { modal } = this.state;

    const searchWordsContainOptions = [
      {
        value: 'contains',
        label: intl.formatMessage({
          id: 'EcFilterProvision.containsOption',
          defaultMessage: 'contains',
          description: 'Search contains option label',
        }),
      },
      {
        value: 'does_not_contain',
        label: intl.formatMessage({
          id: 'EcFilterProvision.doesNotContainOption',
          defaultMessage: 'does not contain',
          description: 'Search does not contain option label',
        }),
      },
    ];

    return (
      <div className={classes.ecFilterFieldWrapper}>
        <div className={classes.ecFilterField}>
          <IconButton
            icon="x"
            onClick={onRemoveClick}
            text={intl.formatMessage({
              id: 'EcFilterProvision.removeFieldButton',
              defaultMessage: 'Remove Field',
              description: 'Remove field button accessibility text',
            })}
          />
          <div className={classes.fieldContainer}>
            <EcSelect
              defaultValue={contains}
              options={searchWordsContainOptions}
              placeholder={intl.formatMessage({
                id: 'EcFilterProvision.selectOptionPlaceholder',
                defaultMessage: 'select option',
                description: 'Placeholder text for select dropdown',
              })}
              onChange={this.handleOnRelationChange}
            />
          </div>
          <hr className={classes.blueLine} />

          <Button
            tooltip={provision}
            id={`field-tooltip-${provision}`}
            text={provision}
            onClick={onFilterNameClick}
            icon="chevron-down"
          />
        </div>
        {this.renderProvisionTextValues()}
        {modal === MODAL_SEARCH_WITHIN_PROVISION &&
          this.renderSearchProvisionModal()}
      </div>
    );
  }
}

EcFilterProvision.propTypes = {
  entity: PropTypes.string.isRequired,
  provision: PropTypes.string.isRequired,
  contains: PropTypes.object.isRequired,
  text_search: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onFilterNameClick: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectSheet(styles)(injectIntl(EcFilterProvision));
